import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { CodeType } from 'src/app/enums/enum';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements OnInit {
// base API url
baseUrl = environment.baseUrl;
frmSingleLicense: FormGroup;
frmMultiLicense: FormGroup;
frmCaptcha: FormGroup;
conditions: any = {};
errorMessage = '';
hasError = false;
licenseFiles: File[] = [];
captcha: any = {};
confirmType = '';
codeTypes: any[] = [];
licenseTypes: any[] = [];
modelNameTypes: any[] = [];
expireDateTypes: any[] = [];
filterExpireDateTypes: any[] = [];
licenseTypesFree: any[] = [];
modelNameTypesFree: any[] = [];
applicationTypes: any[] = [];
license: string = 'Trail';

@ViewChild('confirmSwal') confirmSwal: SwalComponent;
@ViewChild('licenseFileElem') licenseFileElem: ElementRef;

get frmSingle() {
  return this.frmSingleLicense.controls;
}

get frmMulti() {
  return this.frmMultiLicense.controls;
}

constructor(
  private fb: FormBuilder,
  private cd: ChangeDetectorRef,
  private commonSvc: CommonService,
  private spinnerSvc: NgxSpinnerService,
  private route: ActivatedRoute
) {


}

ngOnInit() {
  this.route.params.subscribe(params => {
    this.license = params.license;
    if(this.license === 'free')
    {
      console.log(this.license);
      forkJoin([this.commonSvc.getCodeTypes()]).subscribe(([codeTypes]) => {
        this.codeTypes = codeTypes;
        this.modelNameTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.ModelNameFree
        );
        this.applicationTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.ApplicationType
        );
      });
    }else{
      forkJoin([this.commonSvc.getCodeTypes()]).subscribe(([codeTypes]) => {
        this.codeTypes = codeTypes;
        this.modelNameTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.ModelName
        );
      });
    }
  });


  // initialize single-license form
  this.frmSingleLicense = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    company: [null, [Validators.required,]],
    contact: [null, [Validators.required]],
    contactPersionPhone: [null, [Validators.required]],
    country: [null, [Validators.required]],
    applicationType: [null, [Validators.required]],
    modelName: [null, [Validators.required]],
    license :[this.license],
    macAddress: [
      '',
      [
        Validators.required,
        Validators.pattern('^0002[dD]{1}1[A-Fa-f0-9]{6}$')
      ]
    ],
    licenseType: [null, [Validators.required]],
    expireDate: [null]
  });

  // initialize multi-license form
  this.frmMultiLicense = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    licenseFile: [null, [Validators.required]]
  });

  // captcha form
  this.frmCaptcha = this.fb.group({
    image: [null, [Validators.required]]
  });

  // expire date
  // this.filterExpireDateTypes = this.expireDateTypes.filter(
  //   item =>
  //     item.referenceId === this.frmSingleLicense.get('licenseType').value
  // );
  this.frmSingleLicense.get('modelName').valueChanges.subscribe(val => {
    // get referenceIds
    if (val) {
      if(this.license === 'free')
      {
        const referenceIds = this.modelNameTypes
          .filter(
            item => item.codeTypeId === CodeType.ModelNameFree && item.id === val
          )
          .map(item => [...item.referenceId])[0];
        this.licenseTypes = this.codeTypes.filter(
          item =>
            item.codeTypeId === CodeType.LicenseTypeFree &&
            referenceIds.includes(item.id)
        );
      }
      else
      {
        const referenceIds = this.modelNameTypes
          .filter(
            item => item.codeTypeId === CodeType.ModelName && item.id === val
          )
          .map(item => [...item.referenceId])[0];
        this.licenseTypes = this.codeTypes.filter(
          item =>
            item.codeTypeId === CodeType.LicenseType &&
            referenceIds.includes(item.id)
        );
      }
    }
  });

  // trigger expire date change when licenseType change its value
  this.frmSingleLicense.get('licenseType').valueChanges.subscribe(val => {
    if (val) {
      if(this.license !== 'free')
      {
        const item = this.licenseTypes.filter(
          x => x.codeTypeId === CodeType.LicenseType && x.codeId === val
        )[0];
        this.frmSingleLicense.get('license').setValue("0");
        this.frmSingleLicense.get('company').setValue("...");
        this.frmSingleLicense.get('contact').setValue("...");
        this.frmSingleLicense.get('contactPersionPhone').setValue("...");
        this.frmSingleLicense.get('country').setValue("...");
        this.frmSingleLicense.get('applicationType').setValue("...");
        this.frmSingleLicense.get('expireDate').setValue(item.expireDate);
      }
      else{
        const item = this.licenseTypes.filter(
          x => x.codeTypeId === CodeType.LicenseTypeFree && x.codeId === val
        )[0];
        this.frmSingleLicense.get('license').setValue("1");
        this.frmSingleLicense.get('expireDate').setValue(item.expireDate);
      }
    }
  });
}

handleConfirm(confirmType: string) {
  this.confirmType = confirmType;
  console.log(this.confirmType);
}

beforeOpen(evt) {
  this.commonSvc.getCaptcha().subscribe((response: any) => {
    if (response.status) {
      this.captcha = response.resultObj;
    }
  });
}

submit() {
  this.commonSvc
    .verifyCaptcha({
      key: this.captcha.key,
      image: this.frmCaptcha.get('image').value
    })
    .subscribe((response: any) => {
      if (response.status) {
        this.confirmSwal.nativeSwal.close();
        console.log(this.confirmType);
        switch (this.confirmType) {
          case 'single':
            this.submitSingle();
            break;
          case 'multi':
            this.submitMulti();
            break;
        }
      }
    });
  this.frmCaptcha.patchValue({ image: '' });
}

private submitSingle() {
  this.spinnerSvc.show();
  this.conditions = { ...this.frmSingleLicense.value };
  // override modelName from id to text
  this.conditions.modelName = this.modelNameTypes.filter(
    item => item.id === this.frmSingleLicense.get('modelName').value
  )[0].text;

  this.commonSvc.requestSingleLicense(this.conditions).subscribe(
    (response: any) => {
      if (response.status) {
        window.open(
          `${this.baseUrl}/Generate/File?id=${response.resultObj}`,
          '_blank'
        );
      } else {
        this.hasError = true;
        this.errorMessage = response.msg;
      }
      this.spinnerSvc.hide();
    },
    (err: any) => {
      this.hasError = true;
      this.errorMessage = err.error.exceptionMessage;
      this.spinnerSvc.hide();
    }
  );

  this.frmSingleLicense.reset();
}

private submitSingleAndSendMail() {
  this.spinnerSvc.show();
  this.conditions = { ...this.frmSingleLicense.value };
  // override modelName from id to text
  this.conditions.modelName = this.modelNameTypes.filter(
    item => item.id === this.frmSingleLicense.get('modelName').value
  )[0].text;

  this.commonSvc.requestSingleAndSendMailLicense(this.conditions).subscribe(
    (response: any) => {
      if (response.status) {
        alert(response.msg);
      } else {
        this.hasError = true;
        this.errorMessage = response.msg;
      }

      this.spinnerSvc.hide();
    },
    (err: any) => {
      this.hasError = true;
      this.errorMessage = err.error.exceptionMessage;
      this.spinnerSvc.hide();
    }
  );

  this.frmSingleLicense.reset();
}

private submitMulti() {
  this.spinnerSvc.show();
  // this.commonSvc
  //   .requestMultiLicenses(
  //     this.licenseFiles,
  //     this.frmMultiLicense.get('email').value
  //   )
  //   .subscribe(
  //     (response: any) => {
  //       if (response.status) {
  //         window.open(
  //           `${this.baseUrl}/Generate/File?id=${response.resultObj}`,
  //           '_blank'
  //         );
  //       } else {
  //         this.hasError = true;
  //         this.errorMessage = response.msg;
  //       }
  //       this.spinnerSvc.hide();
  //     },
  //     (err: any) => {
  //       this.hasError = true;
  //       this.errorMessage = err.error.exceptionMessage;
  //       this.spinnerSvc.hide();
  //     }
  //   );

  this.resetFileInput();
}

fileChanged(event: any) {
  const reader = new FileReader();
  if (event.target.files && event.target.files.length) {
    console.log(event);
    const [file] = event.target.files;
    this.licenseFiles = [...this.licenseFiles, file];

    reader.readAsDataURL(file);
    reader.onload = () => {
      this.frmMultiLicense.patchValue({
        file: reader.result
      });
      this.cd.markForCheck();
    };
  }
}

resetFileInput() {
  this.licenseFiles = [];
  this.frmMultiLicense.get('licenseFile').reset();
  this.licenseFileElem.nativeElement.value = '';
}
}
